





















import { listFactory } from '@/main/pages';

import { DOWNLOAD_TEXT, NAME, NO_UNDERLINE_CLASS } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { validateDateFields } from '@/main/utils/commonFunctions';

export default listFactory(NAME, store).extend({
	data() {
		return {
			DownloadUrl: 'DOWNLOAD_URL',
			FileName: 'FILE_NAME',
			EMPTY_VALUES: ['', 'null', 'undefined', null, undefined] as const,
			fromDate: 'RequestedDateFrom',
			toDate: 'RequestedDateTo',
			StatusColumnName: 'STATUS',
			Completed: 'COMPLETED'
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.removeHyperlinkFromEmptyCells();
		});
	},
	updated() {
		this.$nextTick(() => {
			this.removeHyperlinkFromEmptyCells();
		});
	},
	computed: {
		modifiedTableModel() {
			if (!this.tableModel || !(this.tableModel as any).table || !(this.tableModel as any).table.rows) {
				return this.tableModel;
			}

			const downloadColumn = (this.tableModel as any).table.columns.find((col: any) => col.columnName === this.DownloadUrl);
			if (!downloadColumn) return this.tableModel;

			(this.tableModel as any).table.rows.forEach((row: any) => {
				if (row.cells[downloadColumn.columnId] && !row.originalDownloadUrl) {
					row.originalDownloadUrl = row.cells[downloadColumn.columnId];
					row.cells[downloadColumn.columnId] = DOWNLOAD_TEXT;
				}
			});
			return this.tableModel;
		},
	},
	methods: {
		async handleClick(event: any) {
			const statusColumn = (this.tableModel as any).table.columns.find((col: any) => col.columnName === this.StatusColumnName);
			if (statusColumn && String(event.row.cells[statusColumn.columnId]).trim().toUpperCase() === this.Completed) {
				const fileColumn = (this.tableModel as any).table.columns.find((col: any) => col.columnName === this.FileName);
				this.startLoading();
				await apiProvider.Download(event.row.cells[fileColumn.columnId]).catch((err) => {
					if (err.response && err.response.status === 404) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('fileNotFound') });
					} else if (err.response && err.response.status !== 200) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('LocalMsg') });
					}
				});
				this.endLoading();
			}
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await this.tableData();
		},
		dateValidation() {
			if (this.RequestedDateFrom && this.RequestedDateTo) {
				const fromDate = new Date(this.RequestedDateFrom);
				const toDate = new Date(this.RequestedDateTo);
				const Startdate = fromDate.getDate();
				const endtdate = toDate.getDate();
				const startMonth = fromDate.getMonth();
				const endMonth = toDate.getMonth();
				const startYear = fromDate.getFullYear();
				const endYear = toDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					this.RequestedDateFrom = null;
					this.RequestedDateTo = null;
					return false;
				}
				else if (Startdate > endtdate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.RequestedDateTo = null;
					return false;
				}
			}
			else {
				return false;
			}
			return true;
		},
		removeHyperlinkFromEmptyCells() {
			const hyperlinkCells = this.$el.querySelectorAll('.hyperlink-cell');
			hyperlinkCells.forEach(cell => {
				const textContent = cell.textContent?.trim();
				if (!textContent || this.EMPTY_VALUES.includes(textContent as any)) {
					cell.classList.add(NO_UNDERLINE_CLASS);
				} else {
					cell.classList.remove(NO_UNDERLINE_CLASS);
				}
			});
		},
	},
});
